import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered modal-dialog-scrollable",
  style: {"max-width":"750px"}
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = {
  key: 0,
  class: "modal-footer"
}

import { onMounted, ref, watch } from "vue";
import { Modal } from "bootstrap";

export default /*#__PURE__*/_defineComponent({
  __name: 'InformationModal',
  props: {
    showModal: { type: Boolean },
    title: {},
    body: {},
    showFooter: { type: Boolean },
    className: {}
  },
  emits: ["dismiss"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

let modalElement = ref(null);
let modelObject = null;

const state = ref(false);

onMounted(() => {
    modelObject = new Modal(modalElement.value);

    modalElement.value.addEventListener("hidden.bs.modal", (event) => {
        emit("dismiss");
        state.value = false;
    });
});

const emit = __emit;

function handleDismiss() {
    emit("dismiss");
}
function _show() {
    state.value = true;
    modelObject.show();
}

function _hide() {
    state.value = false;
    modelObject.hide();
    emit("dismiss");
}

watch(
    () => props.showModal,
    (showModal, prevShowModal) => {
        state.value = showModal;
        if (showModal) {
            _show();
        } else {
            _hide();
        }
    }
);

__expose({ show: _show });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal fade", [_ctx.className]]),
    "data-bs-backdrop": "static",
    "data-bs-keyboard": "false",
    tabindex: "-1",
    "aria-label": _ctx.title,
    ref_key: "modalElement",
    ref: modalElement
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.title), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", null, [
            _renderSlot(_ctx.$slots, "body", { onDismiss: handleDismiss }, () => [
              _createTextVNode(_toDisplayString(_ctx.body), 1)
            ]),
            _renderSlot(_ctx.$slots, "default")
          ])
        ]),
        (_ctx.showFooter)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _renderSlot(_ctx.$slots, "footer")
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 10, _hoisted_1))
}
}

})